module.exports = __webpack_public_path__ + "img/propertyManager.decbc8e4.png";